export const GIT_BASE_URL = "/v1/git";
export const APPLICATION_BASE_URL = "/v1/applications";
